import { Payload } from "recharts/types/component/DefaultLegendContent";

export function removeObjDuplicateBy<T>(arr: T[], key: keyof T): T[] {
  // Map 의 key: item[key], value: item
  const map = new Map(arr.map((item) => [item[key], item]));
  // values() 를 배열로 꺼내면, 마지막에 등장한 객체가 남습니다.
  return [...map.values()];
}

// export function removeDashData(data: Array<Payload>): [] {
//   return data.filter((item) => !item.payload?.value.includes('_dash')).map()
// }